import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';

export const DotSpinner: FC = () => {
	return (
		<FontAwesomeIcon
			// @ts-expect-error - fortawesome doesn't expect icon prop
			icon={faSpinner}
			spin
		/>
	);
};
